import { useEffect } from 'react';

const ScriptLoader = () => {
  useEffect(() => {
    // Function to load script
    const loadScript = (src, async = true, defer = true) => {
      const script = document.createElement('script');
      script.src = src;
      script.async = async;
      script.defer = defer;
      document.body.appendChild(script);
      return script;
    };

    // Load analytics script after page load
    const analyticsScript = loadScript('https://analytics.example.com/script.js', true, true);

    // Load chat widget after user interaction
    const loadChatWidget = () => {
      loadScript('https://chat.example.com/widget.js', true, true);
      document.removeEventListener('click', loadChatWidget);
    };
    document.addEventListener('click', loadChatWidget);

    // Cleanup
    return () => {
      if (analyticsScript) {
        document.body.removeChild(analyticsScript);
      }
    };
  }, []);

  return null;
};

export default ScriptLoader; 